export default "__VITE_ASSET__DUXv3iC2__"